// Mock data for knowledge base demos - completely isolated from application
// All data is placeholder and does not represent real users or organizations

export interface MockUser {
  id: string;
  email: string;
  name: string;
  role: string;
  team?: string;
}

export interface MockTeam {
  id: string;
  name: string;
  description: string;
  members: string[];
  manager?: string;
}

export interface MockTicket {
  id: string;
  summary: string;
  description: string;
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  priority: 'low' | 'medium' | 'high' | 'urgent';
  assigned_to?: string;
  team?: string;
  created_at: string;
}

export interface MockSmartRule {
  id: string;
  name: string;
  description: string;
  keywords: string[];
  category: string;
  priority: 'low' | 'medium' | 'high' | 'urgent';
  assigned_team: string;
  estimated_resolution: string;
  is_active: boolean;
  approver?: string;
}

export interface MockApproval {
  id: string;
  ticket_id: string;
  title: string;
  description: string;
  requested_by: string;
  assigned_to: string;
  status: 'pending' | 'approved' | 'rejected';
  priority: string;
}

export const mockUsers: MockUser[] = [
  { id: '1', email: 'john.doe@company.com', name: 'John Doe', role: 'Admin', team: 'IT' },
  { id: '2', email: 'jane.smith@company.com', name: 'Jane Smith', role: 'Manager', team: 'IT' },
  { id: '3', email: 'mike.johnson@company.com', name: 'Mike Johnson', role: 'User', team: 'Support' },
  { id: '4', email: 'sarah.williams@company.com', name: 'Sarah Williams', role: 'User', team: 'HR' },
];

export const mockTeams: MockTeam[] = [
  { id: '1', name: 'IT', description: 'IT Support Team', members: ['1', '2'], manager: '1' },
  { id: '2', name: 'Support', description: 'Customer Support Team', members: ['3'], manager: '2' },
  { id: '3', name: 'HR', description: 'Human Resources Team', members: ['4'], manager: '2' },
];

export const mockTickets: MockTicket[] = [
  {
    id: 'T-1234',
    summary: 'Software Installation Request',
    description: 'User needs Adobe Creative Suite installed on their work laptop',
    status: 'open',
    priority: 'medium',
    assigned_to: 'john.doe@company.com',
    team: 'IT',
    created_at: '2025-01-15T10:30:00Z',
  },
  {
    id: 'T-1235',
    summary: 'Badge Access Request',
    description: 'New employee requires badge access for building entry',
    status: 'in_progress',
    priority: 'high',
    assigned_to: 'jane.smith@company.com',
    team: 'HR',
    created_at: '2025-01-15T11:00:00Z',
  },
  {
    id: 'T-1236',
    summary: 'Password Reset',
    description: 'User cannot access their account',
    status: 'resolved',
    priority: 'low',
    assigned_to: 'mike.johnson@company.com',
    team: 'IT',
    created_at: '2025-01-14T14:20:00Z',
  },
];

export const mockSmartRules: MockSmartRule[] = [
  {
    id: '1',
    name: 'Software Installation',
    description: 'Automatically creates tickets for software installation requests',
    keywords: ['install', 'software', 'adobe', 'creative suite', 'photoshop'],
    category: 'Software Installation',
    priority: 'medium',
    assigned_team: 'IT',
    estimated_resolution: '1-2 business days',
    is_active: true,
    approver: 'john.doe@company.com',
  },
  {
    id: '2',
    name: 'Badge Access',
    description: 'Creates tickets for badge and access requests',
    keywords: ['badge', 'access', 'keycard', 'building access'],
    category: 'Account Management',
    priority: 'medium',
    assigned_team: 'HR',
    estimated_resolution: '2-3 business days',
    is_active: true,
  },
  {
    id: '3',
    name: 'Hardware Issues',
    description: 'Routes hardware problems to IT team',
    keywords: ['hardware', 'laptop', 'computer', 'printer', 'monitor', 'broken'],
    category: 'Hardware Issues',
    priority: 'high',
    assigned_team: 'IT',
    estimated_resolution: '1 business day',
    is_active: true,
  },
];

export const mockApprovals: MockApproval[] = [
  {
    id: '1',
    ticket_id: 'T-1234',
    title: 'Software Installation Approval',
    description: 'Please approve Adobe Creative Suite installation for user',
    requested_by: 'mike.johnson@company.com',
    assigned_to: 'john.doe@company.com',
    status: 'pending',
    priority: 'medium',
  },
];

export const mockChatMessages = [
  { role: 'user', content: 'I need Adobe Photoshop installed on my laptop' },
  { role: 'assistant', content: "I'll create a support ticket for your Adobe Photoshop installation request. Our IT team will contact you within 1-2 business days." },
];








